import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CustomerDatabase from './pages/customer-database';
import CalendarView from './pages/calendar-view';
import BookingManagement from './pages/booking-management';
import ServiceManagement from './pages/service-management';
import LoginScreen from './pages/login-screen';
import { useAuth } from './contexts/AuthContext';

// Protected Route wrapper component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/login-screen" element={<Navigate to="/login" replace />} />
        
        {/* Protected Routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <CalendarView />
          </ProtectedRoute>
        } />
        <Route path="/customer-database" element={
          <ProtectedRoute>
            <CustomerDatabase />
          </ProtectedRoute>
        } />
        <Route path="/calendar-view" element={
          <ProtectedRoute>
            <CalendarView />
          </ProtectedRoute>
        } />
        <Route path="/booking-management" element={
          <ProtectedRoute>
            <BookingManagement />
          </ProtectedRoute>
        } />
        <Route path="/service-management" element={
          <ProtectedRoute>
            <ServiceManagement />
          </ProtectedRoute>
        } />
        
        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
